import { Check } from "lucide-react";
import { Reveal, SectionHeader } from "@/components/Reveal";
import { useLeadModals } from "@/components/LeadModals";

const FEATURES = [
  "4 productions per month — your mix of 360° room tours, drone flights & promo clips",
  "Every piece custom-made for your company: your brand, your listings, your market",
  "Unlimited revisions in month 1 — then 2 revisions per production",
  "Scenario templates included",
  "Full commercial rights — 100% royalty-free",
  "48-hour average turnaround",
];

export const Pricing = () => {
  const { openTrial } = useLeadModals();

  return (
    <section id="pricing" className="bg-white py-24 sm:py-32" data-testid="pricing-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          chapter="03 — Pricing"
          title="Simple Pricing"
          sub="One plan. The full 360° offer: room tours, drone flights & promo clips — 80% faster and cheaper than classic production."
        />

        <Reveal>
          <div
            className="mx-auto max-w-2xl overflow-hidden rounded-md border-2 border-hero-black bg-white shadow-[10px_10px_0_#F5C518]"
            data-testid="pricing-card"
          >
            <div className="bg-hero-black px-8 py-5 sm:px-10 flex items-center justify-between gap-4">
              <p className="font-display text-sm font-semibold uppercase tracking-[0.3em] text-hero-gold">Starter Plan</p>
              <span className="rounded-sm bg-hero-gold px-3 py-1 font-display text-sm font-bold uppercase tracking-wide text-hero-black" data-testid="pricing-discount-badge">
                First Month 50% Off
              </span>
            </div>
            <div className="px-8 py-10 sm:px-10">
              <div className="flex flex-wrap items-end gap-x-3 gap-y-1">
                <span className="font-display text-6xl font-bold tracking-tight text-hero-black sm:text-7xl" data-testid="pricing-price">
                  $2,000
                </span>
                <span className="pb-2 text-lg font-medium text-hero-black/60">/month</span>
              </div>
              <p className="mt-3 text-base text-hero-black/70">
                <span className="font-semibold text-hero-black">First month only $1,000</span>{" "}
                <span className="line-through">$2,000</span> — then monthly billing. No setup fees. No long-term contract.
              </p>

              <ul className="mt-8 space-y-4">
                {FEATURES.map((f) => (
                  <li key={f} className="flex items-start gap-3">
                    <span className="mt-0.5 rounded-sm bg-hero-blue/10 p-1">
                      <Check className="h-4 w-4 text-hero-blue" strokeWidth={3} aria-hidden="true" />
                    </span>
                    <span className="text-base leading-relaxed text-hero-black/80">{f}</span>
                  </li>
                ))}
              </ul>

              <button
                onClick={openTrial}
                data-testid="pricing-cta-trial"
                className="mt-10 w-full rounded-md bg-hero-gold px-8 py-4 font-display text-lg font-semibold uppercase tracking-wide text-hero-black shadow-md transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
              >
                Start First Month at 50% Off
              </button>
              <p className="mt-4 text-center text-sm text-hero-black/60">
                30-day money-back guarantee. Cancel anytime, keep every video forever.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
